import _ from 'underscore';
import Backbone from 'backbone';
import AccountImageView from 'web-common/scripts/views/AccountImageView';

let EditProfileImageView = Backbone.View.extend({
    events: {
        'click .sign-up-image-button': 'editProfileImage',
        'click .profile-img-edit-button': 'editProfileImage',
        'click .profile-img-edit-button-mobile': 'editProfileImage'
    },

    initialize: function(options) {
        options = options || {};
        this.imageProperty = options.imageProperty;
        this.parentView = options.parentView;
        this.initializeUploadCloudinaryView();
    },

    initializeUploadCloudinaryView: function() {
        this.imageView = new AccountImageView({
            cloudinaryOptions: {
                croppingAspectRatio: 0.99999,
                maxImageWidth: 750,
                showSkipCropButton: false
            }
        });
        this.listenTo(this.imageView, 'success', this.editProfileImage);
    },

    remove: function() {
        this.imageView.remove();
    },

    editProfileImage: function() {
        let thisView = this;
        let success = function() {
            thisView.model.set(
                thisView.imageProperty,
                thisView.imageView.image
            );
        };
        this.imageView.uploadImage({
            success: success
        });
    }
});

export default EditProfileImageView;
